import { Fragment, h } from 'preact'; /** @jsx h */
import { useContext, useEffect, useState } from 'preact/hooks';
import { NotificationContext } from '../../../context/NotificationContext';

import './NotificationBanner.scss';

const NotificationBanner = () => {
    const {
        notification,
        clearNotificationTimeout,
        restartNotificationTimeout,
        closeNotification
    } = useContext(NotificationContext);

    const [headerUp, setHeaderUp] = useState(false);

    // UseEffect for header up
    useEffect(() => {
        function updateHeaderUp() {
            const header = document.querySelector('header');
            if (header) {
                if (header.classList.contains('header-up')) {
                    setHeaderUp(true);
                } else {
                    setHeaderUp(false);
                }
            }
        }

        window.addEventListener('scroll', updateHeaderUp);

        // Run the function once to update the state initially
        updateHeaderUp();

        return () => {
            window.removeEventListener('scroll', updateHeaderUp);
        };
    }, []);

    return (
        <div
            className={`notification-banner ${notification.type} ${
                headerUp ? 'header-up' : 'header-down'
            } ${notification.isOpen ? 'open' : ''}`}
            onMouseEnter={clearNotificationTimeout}
            onMouseLeave={() => restartNotificationTimeout(5)}
        >
            <span className="material-symbols-outlined exit-icon" onClick={closeNotification}>
                close
            </span>
            <span className="material-symbols-outlined icon">
                {notification.type === 'success' ? 'check_circle' : 'error'}
            </span>
            <p className="notification-message">
                {notification.message}
                {notification.link.text && (
                    <>
                        {' '}
                        <br />
                        <a href={notification.link.url}>{notification.link.text}</a>
                    </>
                )}
            </p>
        </div>
    );
};

export default NotificationBanner;
